import React from "react";
import {
  Facebook,
  Twitter,
  Youtube,
  Instagram,
  Mail,
  Phone,
  MapPin,
  Clock,
  ChevronRight,
} from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import logo from "../assets/images/logo/Header-logo.jpeg";

// PREMIUM LAW THEME COLORS
const COLORS = {
  black: "#0A0A0A",
  brown: "#8B5E3C",
  lightBrown: "#B08D57",
  white: "#FFFFFF",
  gray: "#BFBFBF",
};

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <>
    <footer
      className="pt-20 pb-10 px-6 md:px-12 border-t"
      style={{
        backgroundColor: COLORS.black,
        borderColor: COLORS.brown,
      }}
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
        {/* LOGO + ABOUT */}
        <div className="space-y-6">
          <img src={logo} alt="Logo" className="w-56 object-contain" />

          <div
            className="w-20 h-[2px]"
            style={{ backgroundColor: COLORS.brown }}
          />

          <p className="text-gray-400 leading-relaxed text-sm">
            Delivering trusted legal solutions with integrity, precision, and
            dedication. We ensure justice with a client-first approach.
          </p>

          <div className="flex gap-4 pt-3">
            <a
              href="https://www.facebook.com/advakashgiri"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialIcon icon={<Facebook size={18} />} />
            </a>

            {/* <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialIcon icon={<Twitter size={18} />} />
            </a> */}

            {/* <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialIcon icon={<Youtube size={18} />} />
            </a> */}

            <a
              href="https://www.instagram.com/p/DWOYXHLCf_G/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialIcon icon={<Instagram size={18} />} />
            </a>
          </div>
        </div>

        {/* QUICK LINKS */}
        <div>
          <SectionTitle title="Quick Links" />

          <ul className="space-y-4 mt-6">
            <FooterLink label="Home" href="/" />
            <FooterLink label="About Us" href="/about-us" />
            <FooterLink label="Practice Areas" href="/practice-areas" />
            <FooterLink label="Blogs" href="/blog" />
            <FooterLink label="Contact" href="/contact-us" />
          </ul>
        </div>

        {/* SERVICES */}
        <div>
          <SectionTitle title="Practice Areas" />

          <ul className="space-y-4 mt-6">
            <FooterLink label="Civil Litigation" href="#" />
            <FooterLink label="Criminal Defense" href="#" />
            <FooterLink label="Corporate Law" href="#" />
            <FooterLink label="Cyber Law" href="#" />
            <FooterLink label="Family Law" href="#" />
          </ul>
        </div>

        {/* CONTACT */}
        <div>
          <SectionTitle title="Contact" />

          <div className="space-y-6 mt-6 text-sm text-gray-400">
            <ContactItem
              icon={<MapPin size={18} />}
              text={`Adv Akash Giri, Chamber no-F-224, Karkardooma Rd, Arjun Gali, Vishwas Nagar, Shahdara, New Delhi, Delhi, 110092`}
            />

            <ContactItem
              icon={<Phone size={18} />}
              text="+91 86503 37072"
              highlight
            />

            <ContactItem
              icon={<Mail size={18} />}
              text="akashgiri000@gmail.com"
            />

            <ContactItem
              icon={<Clock size={18} />}
              text="Mon – Sat: 09:00 – 19:00"
            />
          </div>
        </div>
      </div>

      {/* BOTTOM BAR */}
      <div
        className="border-t pt-6 text-center text-xs"
        style={{ borderColor: "#222" }}
      >
        <p className="text-gray-500 tracking-wider">
          © {year} Adv Akash Giri. All Rights Reserved.
        </p>

        <p className="text-gray-600 mt-2">
          Designed & Developed by{" "}
          <a
            href="https://www.digimarqtechnology.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold"
            style={{ color: COLORS.lightBrown }}
          >
            Digimarq Technology Pvt Ltd
          </a>
        </p>
      </div>
    </footer>
    {/* ✅ FLOATING WHATSAPP BUTTON */}
<a
  href="https://wa.me/918650337072"
  target="_blank"
  rel="noopener noreferrer"
  className="fixed bottom-6 right-6 z-50"
>
  <div className="w-14 h-14 flex items-center justify-center rounded-full shadow-lg bg-green-500 hover:scale-110 transition-all duration-300 animate-pulse">
    <FaWhatsapp size={28} className="text-white" />
  </div>
</a>
     
    </>
  );
};

/* ---------------- SUB COMPONENTS ---------------- */

const SectionTitle = ({ title }) => (
  <h3
    className="text-sm uppercase tracking-widest font-semibold"
    style={{ color: "#EAEAEA" }}
  >
    {title}
    <div className="w-10 h-[2px] mt-2" style={{ backgroundColor: "#8B5E3C" }} />
  </h3>
);

const SocialIcon = ({ icon }) => (
  <div
    className="w-9 h-9 flex items-center justify-center border rounded-full cursor-pointer transition-all duration-300"
    style={{
      borderColor: "#2A2A2A",
      color: "#BFBFBF",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "#8B5E3C";
      e.currentTarget.style.color = "#fff";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "transparent";
      e.currentTarget.style.color = "#BFBFBF";
    }}
  >
    {icon}
  </div>
);

const FooterLink = ({ label, href }) => (
  <li className="group flex items-center text-sm cursor-pointer">
    <ChevronRight
      size={14}
      className="mr-2 opacity-0 -translate-x-3 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
      style={{ color: "#8B5E3C" }}
    />
    <a
      href={href}
      className="text-gray-400 group-hover:text-white transition-all duration-300 group-hover:translate-x-1"
    >
      {label}
    </a>
  </li>
);

const ContactItem = ({ icon, text, highlight }) => (
  <div className="flex items-start gap-3">
    <div style={{ color: "#8B5E3C" }}>{icon}</div>
    <span
      className={`leading-relaxed ${
        highlight ? "text-white font-medium" : "text-gray-400"
      }`}
    >
      {text}
    </span>
  </div>


);

export default Footer;



